import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const dynamicTemplateTagName = 'div';
let count = 1;
const idGen = new IDGenerator('wm_repeat-template');

register('wm-repeat-template', (): IBuildTaskDef => {
  return {
    requires: ['wm-accordion', 'wm-tabs', 'wm-wizard'],
    pre: (attrs, shared, parentAccordion, parentTab): any => {
      const counter = idGen.nextUid();
      return `<div class="app-repeattemplate" wmRepeatTemplate wmsTransclude ${getAttrMarkup(attrs)}>`;
    },
    post: () => `</div>`
  };
});

export default () => {};
